import React, { useState, useEffect } from 'react';
import LoginForm from './components/Login/LoginForm';
import MainApp from './MainApp';
import DroneGuestPage from './components/Drones/DroneGuestPage';
import PreemergenciaFormPage from './components/Alerpat/PreemergenciaFormPage';
import { jwtDecode } from 'jwt-decode';
import { requestAndSendFirebaseToken } from './helpers/tokenManager';
import './helpers/listener';
import { API_URL } from './config';
import { authFetch } from './utils';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [ roles , setRoles ] = useState([]);

    const getRolesFromToken = (token = localStorage.getItem('token')) => {
        if (!token) return [];

        try {
            const { roles } = jwtDecode(token);
            return Array.isArray(roles) ? roles : [];
        } catch {
            return [];
        }
    };

    const can = (permissionOrRoles) => {
        if (Array.isArray(permissionOrRoles)) {
            return permissionOrRoles.some(r => roles.includes(r));
        }

        return roles.includes(permissionOrRoles);
    };


    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) return;

        try {
            const { exp } = jwtDecode(token);
            const isExpired = Date.now() >= exp * 1000;

            if (isExpired) throw new Error();

            setIsAuthenticated(true);
            setRoles(getRolesFromToken(token));
            requestAndSendFirebaseToken();
        } catch {
            localStorage.removeItem('token');
            setIsAuthenticated(false);
            setRoles([]);
        }
    }, []);



    const handleLogout = async () => {
        try {
            await authFetch(`${API_URL}auth/logout`, { method: 'POST' });
        } catch (err) {
            console.error("Error registrando logout:", err);
        }

        localStorage.clear();
        setIsAuthenticated(false);
        setRoles([]);
        };


    if (window.location.pathname === '/drone-guest') {
        return <DroneGuestPage />;
    }

    const isPreemergenciaOnly = can('preemergencia-sender') && !can(['admin', 'alerpat-user']);

    return isAuthenticated ? (
        isPreemergenciaOnly ? (
            <PreemergenciaFormPage onLogout={handleLogout} />
        ) : (
            <MainApp onLogout={handleLogout} can={can} />
        )
    ) : (
        <LoginForm
            onLoginSuccess={async () => {
                setIsAuthenticated(true);
                setRoles(getRolesFromToken());

                await requestAndSendFirebaseToken();
            }}
            />

    );
}

export default App;
